import Modal from "./Modal";

const QnA = ({ hide }) => {

    return <Modal handleClose={hide} show={true} title={'Q&A'} width="45em" Height="120px">
            Questions and Answers
        </Modal>
    
} 
export default QnA;